var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('header-title',{attrs:{"title":"Guía de compulsa"}}),_c('user-guide',{attrs:{"tactivity":"compulsa"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }